<div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
  <!-- Título -->

  <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
    <div class="d-flex flex-wrap justify-content-between">
      <div class="flex-grow-1 titulo_texto_posicao">
        <div class="titulo_texto">Alterar Senha</div>
      </div>
    </div>
  </div>

  <!-- Dados -->

  <div class="pt-3 pr-4 pb-4 pl-4">
    <form [formGroup]="formDados" (ngSubmit)="salvar()">
      <div class="form-row">
        <div class="form-group col-sm-4">
          <label><b>Nova Senha:</b></label>

          <div class="input-group input-group-sm">
            <input class="form-control form-control-sm" [type]="exibirSenha ? 'text' : 'password'" name="nova_senha" [ngClass]="{ 'is-invalid': enviado && f.nova_senha.errors?.required }" formControlName="nova_senha" />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" (click)="exibirSenha = !exibirSenha">
                <i class="fa" [ngClass]="exibirSenha ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
          </div>

          @if (enviado && f.nova_senha.errors?.required) {
            <div class="erro pt-1">Nova Senha em branco!</div>
          }
          @if (enviado && f.nova_senha.errors?.invalid) {
            <div class="erro pt-1">Mínimo de 6 dígitos!</div>
          }
        </div>
      </div>

      <hr class="mt-2 mb-2" />

      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 text-right">
          <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
        </div>
      </div>
    </form>
  </div>
</div>
